import { render, staticRenderFns } from "./4_PagoArancel.vue?vue&type=template&id=065861a3&scoped=true"
import script from "./4_PagoArancel.vue?vue&type=script&lang=ts"
export * from "./4_PagoArancel.vue?vue&type=script&lang=ts"
import style0 from "./4_PagoArancel.vue?vue&type=style&index=0&id=065861a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065861a3",
  null
  
)

export default component.exports